import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class InfoValue extends DesigntimeComponent {
    static staticName = "Info (Value)";
    static staticId = "infoValue";

    contextContentUrl;

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            header: { value: "Default **header** text" },
            text: { value: "£ 151/month*" },
            subtext: { value: "*Data is based on Swedish research, the median of active players’ stake per month" },
            buttontext: { value: "Next" },
            imageurl: { value: "placeholder.png", dontTranslate: true },
            imageclass: { value: "sid-image-circle", dontTranslate: true }
        };
    }

    getRuntimeView(context) {
        let $view = $("<div></div>");
        let $textbox = $("<div class='sid-question-text'></div>");
        $textbox.append("<h3>" + componentHelpers.mdToHtml(this.values.header.value) + "</h3>");
        $textbox.append("<p class='sid-info-insert-value'>" + this.values.text.value + "</p>");
        $textbox.append("<p class='sid-info-insert-asterisk'>" + this.values.subtext.value + "</p>");
        $view.append($textbox);

        let $imagebox = $("<div class='sid-question-image'></div>");
        if (this.values.imageurl.value) {
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }

        return $view;
    }
}

export { InfoValue }
